import styled from 'styled-components/macro';

import { white, grey30, grey5, brandLight } from 'variables/colors';
import { fontWeightSemiBold } from 'variables/font';
import {
  border,
  borderRadius,
  boxShadow,
  boxShadowHeavy,
} from 'variables/general';
import Button from 'components/ui/Button';

export const Component = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5em;
`;

export const SearchBar = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  align-items: center;
  margin-right: 1em;
  padding: 12.5px;
  background-color: ${white};
  border-bottom: ${border};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadow};
`;

export const Search = styled.input`
  flex-grow: 1;
  margin-left: 0.5em;
  font-size: 0.875em;
  border: 0;

  &:focus {
    border: 0;
    outline: 0;
  }

  &::placeholder {
    color: ${grey30};
    font-weight: ${fontWeightSemiBold};
  }
`;

export const Suggestions = styled.div`
  position: absolute;
  top: 4.5em;
  left: 0;
  z-index: 900;
  width: 100%;
  padding: 1em 0;
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadowHeavy};
`;

export const Suggestion = styled.div`
  padding: 1em;
  font-size: 0.875em;
  cursor: pointer;

  &:nth-of-type(${({ suggestionActiveItem }) => suggestionActiveItem}) {
    background-color: ${brandLight};
  }

  &:hover {
    background-color: ${grey5};
  }
`;

export const SuggestionPrimary = styled.h5`
  margin: 0 0 0.75em 1em;
`;

export const SuggestionSecondary = styled.p`
  margin-left: 1em;
`;

export const SuggestionSecondaryText = styled.span`
  font-size: 1em;

  &:not(:last-of-type)::after {
    padding: 0 1em;
    content: '|';
  }
`;

export const AddButton = styled(Button)`
  justify-self: flex-start;
`;
